import '@pec/aion-ui-core/index.css';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '@pec/aion-ui-i18next/index';
import { App } from './App';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
